module.exports = __webpack_public_path__ + "static/img/1.056d2e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/1.png
// module id = Guq6
// module chunks = 19